import LoadingSkeletonImageDynamic from "../../../components/LoadingSkeletonImageDynamic";
import { ClipLoader } from "react-spinners";
import { useTheme } from "../../../context/ThemeProvider";
import { useCallHistory } from "../../../store/api/useCallHistory";
import CallInCallHistory from "./CallInCallHistory";
import {
  formatCallDuration,
  formatDate,
} from "../../../utils/formatUTCtoLocalDate";
import ShowSavedName from "../../../components/ShowSavedName";
import SearchNotFoundAnimation from "../../../components/SearchNotFoundAnimation";
import TextTranslate from "../../../utils/TextTranslate";
import { useTimeFormatOptions } from "../../../hooks/useTimeFormatOptions";
import { useAppSelector } from "../../../utils/hooks";
import {
  resolveCallHistoryDirection,
  resolveCallHistoryPeer,
} from "../../../utils/callHistoryPeer";

export default function AllCallsHIstory() {
  const { data: callHistory, isLoading } = useCallHistory();
  const { languageCode } = useTimeFormatOptions();
  const userData = useAppSelector((state) => state.userData);
  // @ts-ignore
  const { theme } = useTheme();
  const records =
    callHistory?.data?.Records?.filter((e) => e?.Calls?.length > 0) || [];

  if (isLoading) {
    return (
      <div className="grid min-h-[50vh] place-content-center">
        <ClipLoader size={22} color={theme == "dark" ? "white" : "black"} />
      </div>
    );
  }

  if (!records.length) {
    return (
      <div className="grid min-h-[50vh] place-content-center gap-4 text-center">
        <SearchNotFoundAnimation />
        <div className="text-[15px] text-lightText">
          <TextTranslate text="No Calls Found" />
        </div>
      </div>
    );
  }

  return (
    <div className="overflow-hidden rounded-2xl bg-primary shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
      {records.map((e, index) => {
        const call = e.Calls[0];
        const isGroup = e?.Chat.chat_type == "group";
        const peer = resolveCallHistoryPeer(e, userData.user_id);
        const direction = resolveCallHistoryDirection(e, userData.user_id);
        const isMissed = direction === "missed";

        return (
          <div
            key={(e as any).id || `${e.createdAt}-${index}`}
            className={`flex items-center gap-3 px-3 py-3 ${
              index > 0
                ? "border-t border-black/[0.06] dark:border-white/[0.08]"
                : ""
            }`}
          >
            <div className="h-11 w-11 shrink-0 overflow-hidden rounded-full">
              <LoadingSkeletonImageDynamic
                radius=""
                className="h-full w-full rounded-full object-cover"
                image_height=""
                image_url={
                  isGroup
                    ? e?.Chat.group_icon
                    : peer?.profile_pic || call?.caller?.profile_pic
                }
                image_width=""
              />
            </div>

            <div className="min-w-0 flex-1">
              <div
                className={`truncate text-[15px] font-semibold capitalize ${
                  isMissed ? "text-[#FF3B30]" : "text-darkText"
                }`}
              >
                {isGroup ? (
                  e?.Chat.group_name
                ) : (
                  <ShowSavedName
                    user_id={(
                      peer?.user_id || call?.caller?.user_id
                    )?.toString()}
                    name={
                      peer?.full_name ||
                      peer?.user_name ||
                      call?.caller?.user_name
                    }
                  />
                )}
              </div>
              <CallInCallHistory callData={e} />
            </div>

            <div className="shrink-0 text-right text-[11px] tabular-nums text-lightText">
              <div>{formatDate(e.createdAt.toString())}</div>
              {call?.call_duration ? (
                <div className="mt-0.5">
                  {formatCallDuration(call.call_duration, languageCode)}
                </div>
              ) : null}
            </div>
          </div>
        );
      })}
    </div>
  );
}
